import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";
import { t } from "@/i18n";

export function OiCounter({ refresh = 0 }) {
  const api = useApi();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/oi/stats").then((r) => setS(r.data)).catch(() => {}); }, [api, refresh]);
  if (!s) return null;
  return (
    <div className="card !py-3 text-sm stack-sm" data-testid="oi-counter">
      <span className="mono-label">{t("Team totals")}</span>
      <div className="flex flex-wrap gap-x-4 gap-y-1">
        <span>{t("Answered from OI base")}: <b data-testid="oi-answered">{s.answered}</b></span>
        <span>{t("Sent to manager")}: <b data-testid="oi-sent">{s.sent}</b></span>
      </div>
    </div>
  );
}
